<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="uzm4F59whZiM9YRiq8s8aF2">
<p class="CHAPTER1" lang="en-US">Acknowledgments</p>
<p class="FIRSTPARAGRAPH" lang="en-US">Thanks to the music of <span class="italics">Neil Finn, Radiohead, Spoon,</span> and <span class="italics">U2</span> that helped inspire my long hours of writing. Thanks to the cast and crew of my favorite shows – <span class="italics">For All Mankind, The Expanse, Breaking Bad, Better Call Saul, </span>and many more. To the podcasts and content creators I enjoyed when I needed a break <span class="italics">The Bearded Ones, Stephen Colbert, Seth Meyers, Jimmy Kimmel, I Hate It but I Love It, The Why Files, </span>and anything <span class="italics">Alex Schmidt </span>does. Thanks to beta-readers like <span class="italics">Jay, Mark, Matthew,</span> and <span class="italics">Vinny</span>. To <span class="italics">Elijah Toten</span> for the kickass cover and finally to <span class="italics">Rowe Carenen</span> for the fabulous editing job! Buckle up Rowe!</p>
<p class="Normal-Space" lang="en-US">And last but not least, thanks to <span class="italics">Kedakai! ... As God Made Her.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?86a23cc0